import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type ChangePasswordState = {
  loading: boolean;
  error: boolean;
  errorMessage: string | null;
  success: boolean;
  data: unknown | null;
};

const initialState: ChangePasswordState = {
  loading: false,
  error: false,
  errorMessage: null,
  success: false,
  data: null,
};

interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

export const changePassword = createAsyncThunk<
  unknown,
  ChangePasswordPayload,
  { rejectValue: string }
>('changePassword', async (payload, thunkAPI) => {
  try {
    const { data } = await api.put('/api/account/password', {
      old_password: payload.oldPassword,
      new_password: payload.newPassword,
    });
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      'Failed to change password';
    return thunkAPI.rejectWithValue(message);
  }
});

const changePasswordSlice = createSlice({
  name: 'changePassword',
  initialState,
  reducers: {
    resetChangePassword: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changePassword.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = null;
      state.success = false;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload ?? 'Failed to change password';
    });
  },
});

export const { resetChangePassword } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;
